import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import logoImg from "../../assets/icons/logo-lisa.svg";
import { Header } from "../../components/Header";
import api from "../../service/api";
import { Container, Content } from "./styles";
import { ClipLoader } from "react-spinners";

export function Welcome() {
  const navigate = useNavigate();
  const [color] = useState("#ffffff");
  const [loading, setLoading] = useState<boolean>(true);

  async function getDeviceConfig() {
    try {
      const request = await api
        .get(`/device/config`, {
          withCredentials: true
        })
        .then((response) => {
          try{

            const scenarios = JSON.stringify(response.data.scenarios);
            localStorage.setItem("scenarios", scenarios);
            // console.log('salvou scenarios');
            
            localStorage.setItem("lisaModel", response.data.lisa3DModelAddress);
            // console.log('salvou lisa3DModelAddress');
            localStorage.setItem("tutorialAddress", response.data.tutorialVideoAddress);
            // console.log('salvou tutorialAddress');
            
            // const animations = JSON.stringify(response.data.animations);
            // localStorage.setItem("macroAnimations", animations);
            // console.log('salvou macroAnimations');
          } catch (error) {
            console.error(error)
          } finally {
            setLoading(false);
            navigate("/home");
          }
          // return response.data
        });

    } catch (error: any) {
      if (error.code === "ERR_BAD_REQUEST") {
        localStorage.setItem("deviceIp", error.response.data.ip);
        navigate("/naoautorizado");
      }
    }
  }

  const toggleFullSceen = (): void => {
    if (process.env.REACT_APP_ENABLE_TOGGLE_FULLSCREEN === "true") {
      document.body.requestFullscreen();
    }
  };

  useEffect(() => {
    toggleFullSceen();
    getDeviceConfig();
  }, [navigate]);

  return (
    <>
      <Container>
        <Content>
          <img src={logoImg} alt="Logo da Lisa" />
          <p>Boas-Vindas</p>
          <ClipLoader
            color={color}
            loading={loading}
            size={150}
            aria-label="Loading..."
            data-testid="loader"
          />
        </Content>
      </Container>
    </>
  );
}
